"use client"; // Error components must be Client Components

import { Page } from "@/app/common/page-component";

// biome-ignore lint: Exporting Error is required by Next.js
export default function Error() {
    return (
        <html lang="en">
            <body>
                <Page withNavBar withFooter>
                    <div className="mx-4 my-16 flex flex-col items-center gap-4 md:my-32">
                        <h2 className="text-4xl">Something went wrong!</h2>
                    </div>
                </Page>
            </body>
        </html>
    );
}
